import {lazy} from 'react';

const routeLoaders = {
  '/': () => import('../pages/WorkspaceHome'),
  '/accountant/invite': () => import('../pages/AccountantInvitePage'),
  '/accountant/requests': () => import('../pages/AccountantRequestsPage'),
  '/settings/delete-account': () => import('../pages/AccountDeletionPage'),
  '/auth/confirm': () => import('../pages/AuthConfirmPage'),
  '/banking': () => import('../pages/BankingPage'),
  '/cash-flow': () => import('../pages/CashFlowPage'),
  '/settings/blog': () => import('../pages/BlogEditorPage'),
  '/businesses/new': () => import('../pages/BusinessCreationPage'),
  '/contractor/invite': () => import('../pages/ContractorInvitePage'),
  '/contractor/submissions': () => import('../pages/ContractorSubmissionsPage'),
  '/contractors': () => import('../pages/ContractorsPage'),
  '/contractors/invoices': () => import('../pages/ContractorInvoicesPage'),
  '/contractors/payment': () => import('../pages/ContractorPaymentPage'),
  '/contractors/portal': () => import('../pages/ContractorPortalPage'),
  '/expenses': () => import('../pages/ExpensesPage'),
  '/expenses/new': () => import('../pages/ExpenseFormPage'),
  '/features': () => import('../pages/FeatureRequestsPage'),
  '/forgot-password': () => import('../pages/ForgotPasswordPage'),
  '/income': () => import('../pages/IncomePage'),
  '/income/new': () => import('../pages/IncomeFormPage'),
  '/invoice/public': () => import('../pages/PublicInvoicePage'),
  '/invoices': () => import('../pages/InvoicesList'),
  '/invoices/new': () => import('../pages/InvoiceBuilderPage'),
  '/invoices/recurring': () => import('../pages/RecurringInvoicesPage'),
  '/login': () => import('../pages/LoginPage'),
  '/attention': () => import('../pages/NeedsAttentionPage'),
  '/settings/merchant-rules': () => import('../pages/MerchantRulesPage'),
  '/onboarding': () => import('../pages/OnboardingPage'),
  '/settings/health': () => import('../pages/ProductionHealthPage'),
  '/receipt-inbox': () => import('../pages/ReceiptInboxPage'),
  '/reminders': () => import('../pages/RemindersPage'),
  '/repayments': () => import('../pages/RepaymentsPage'),
  '/reset-password': () => import('../pages/ResetPasswordPage'),
  '/review': () => import('../pages/ReviewPage'),
  '/settings': () => import('../pages/BusinessSettingsPage'),
  '/settings/accountants': () => import('../pages/AccountantAccessPage'),
  '/settings/billing': () => import('../pages/BillingPage'),
  '/settings/payment-methods': () => import('../pages/PaymentMethodsPage'),
  '/settings/profile': () => import('../pages/ProfilePage'),
  '/signup': () => import('../pages/SignupPage'),
  '/support': () => import('../pages/SupportPage'),
  '/tax': () => import('../pages/TaxCentrePage'),
  '/trips': () => import('../pages/TripsPage'),
  '/trips/new': () => import('../pages/TripFormPage'),
  '/vehicles': () => import('../pages/VehiclesPage')
};

const routePromises = new Map();

function loadRoute(path) {
  const loader = routeLoaders[path];
  if (!loader) return Promise.reject(new Error(`Unknown route: ${path}`));
  if (!routePromises.has(path)) {
    routePromises.set(path, loader().catch((error) => {
      routePromises.delete(path);
      throw error;
    }));
  }
  return routePromises.get(path);
}

const lazyRoute = (path) => lazy(() => loadRoute(path));

export function preloadRoute(path) {
  if (!routeLoaders[path]) return Promise.resolve();
  return loadRoute(path).catch(() => undefined);
}

export const WorkspaceHome = lazyRoute('/');
export const AccountantInvitePage = lazyRoute('/accountant/invite');
export const AccountantRequestsPage = lazyRoute('/accountant/requests');
export const AccountDeletionPage = lazyRoute('/settings/delete-account');
export const AuthConfirmPage = lazyRoute('/auth/confirm');
export const BankingPage = lazyRoute('/banking');
export const CashFlowPage = lazyRoute('/cash-flow');
export const BlogEditorPage = lazyRoute('/settings/blog');
export const BusinessCreationPage = lazyRoute('/businesses/new');
export const ContractorInvitePage = lazyRoute('/contractor/invite');
export const ContractorSubmissionsPage = lazyRoute('/contractor/submissions');
export const ContractorsPage = lazyRoute('/contractors');
export const ContractorInvoicesPage = lazyRoute('/contractors/invoices');
export const ContractorPaymentPage = lazyRoute('/contractors/payment');
export const ContractorPortalPage = lazyRoute('/contractors/portal');
export const ExpensesPage = lazyRoute('/expenses');
export const ExpenseFormPage = lazyRoute('/expenses/new');
export const FeatureRequestsPage = lazyRoute('/features');
export const ForgotPasswordPage = lazyRoute('/forgot-password');
export const IncomePage = lazyRoute('/income');
export const IncomeFormPage = lazyRoute('/income/new');
export const PublicInvoicePage = lazyRoute('/invoice/public');
export const InvoicesList = lazyRoute('/invoices');
export const InvoiceBuilderPage = lazyRoute('/invoices/new');
export const RecurringInvoicesPage = lazyRoute('/invoices/recurring');
export const LoginPage = lazyRoute('/login');
export const NeedsAttentionPage = lazyRoute('/attention');
export const MerchantRulesPage = lazyRoute('/settings/merchant-rules');
export const OnboardingPage = lazyRoute('/onboarding');
export const PaymentMethodsPage = lazyRoute('/settings/payment-methods');
export const ProductionHealthPage = lazyRoute('/settings/health');
export const ProfilePage = lazyRoute('/settings/profile');
export const ReceiptInboxPage = lazyRoute('/receipt-inbox');
export const RemindersPage = lazyRoute('/reminders');
export const RepaymentsPage = lazyRoute('/repayments');
export const ResetPasswordPage = lazyRoute('/reset-password');
export const ReviewPage = lazyRoute('/review');
export const SignupPage = lazyRoute('/signup');
export const SupportPage = lazyRoute('/support');
export const TaxCentrePage = lazyRoute('/tax');
export const TripFormPage = lazyRoute('/trips/new');
export const TripsPage = lazyRoute('/trips');
export const VehiclesPage = lazyRoute('/vehicles');
export const AccountantAccessPage = lazyRoute('/settings/accountants');
export const BillingPage = lazyRoute('/settings/billing');
export const BusinessSettingsPage = lazyRoute('/settings');
